// extracted by mini-css-extract-plugin
export var active = "_1x-d";
export var blink = "_1x-e";
export var container = "_1x-5";
export var controls = "_1x-0";
export var controlsRight = "_1x-1";
export var fakeCursor = "_1x-c";
export var hidden = "_1x-b";
export var quillContainerSmall = "_1x-7";
export var quillEditor = "_1x-6";
export var quillEditorSmall = "_1x-8";
export var quillFormatButtons = "_1x-a";
export var quillToolbar = "_1x-9";
export var removePadding = "_1x-2";
export var state = "_1x-3";
export var stateTitle = "_1x-4";